<template>
    <rkm-modal
        :title="modalTitle"
        extra-large
        ref="RkmModal"
    >
        <rkm-form
            v-if="item"
            ref="RkmForm"
        >
            <rkm-table
                :fields="fields"
                :items="item.lotes"
            >
                <template v-slot:cell(quantidadeEnviada)="row">
                    <rkm-form-input
                        v-if="model.statusId === enums.requisicaoStatus.PENDENTE"
                        :validations="{ max_value: row.item.quantidadeEstoque }"
                        class="m-0"
                        name="Quantidade enviada"
                        type="number"
                        v-model="row.item.quantidadeEnviada"
                    />

                    <span v-else>{{ row.item.quantidadeEnviada }}</span>
                </template>

                <template v-slot:cell(quantidadeRecebida)="row">
                    <rkm-form-input
                        v-if="model.statusId === enums.requisicaoStatus.RESPONDIDA"
                        :validations="{ max_value: row.item.quantidadeEnviada }"
                        class="m-0"
                        name="Quantidade recebida"
                        type="number"
                        v-model="row.item.quantidadeRecebida"
                    />

                    <span v-else>{{ row.item.quantidadeRecebida }}</span>
                </template>
            </rkm-table>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                {{ cancelButtonTitle }}
            </rkm-button>

            <rkm-button
                v-if="saveButtonShow"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import requisicaoStatus from '@/enums/imunizacao/requisicaoStatus'

// Mixins.
import { object } from '@/mixins'

export default {
    computed: {
        fields() {
            const fields = []

            if (this.model.statusId === this.enums.requisicaoStatus.PENDENTE) {
                fields.push(
                    { key: 'quantidadeEstoque', label: 'Quantidade em estoque' },
                    { key: 'lote', label: 'Lote' },
                    { key: 'dataValidadeLote', label: 'Validade do lote' },
                    { key: 'quantidadeEnviada', label: 'Quantidade enviada' },
                )
            }
            else if (this.model.statusId === this.enums.requisicaoStatus.RESPONDIDA) {
                if (this.model.salaVacinacaoIdPara === this.additionals.salaVacinacaoLogada.id) {
                    fields.push(
                        { key: 'quantidadeEnviada', label: 'Quantidade enviada' },
                        { key: 'lote', label: 'Lote' },
                        { key: 'dataValidadeLote', label: 'Validade do lote' },
                    )
                }

                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    fields.push(
                        { key: 'quantidadeEnviada', label: 'Quantidade enviada' },
                        { key: 'lote', label: 'Lote' },
                        { key: 'dataValidadeLote', label: 'Validade do lote' },
                        { key: 'quantidadeRecebida', label: 'Quantidade recebida' },
                    )
                }
            }
            else if (this.model.statusId === this.enums.requisicaoStatus.FINALIZADA) {
                if (this.model.salaVacinacaoIdPara === this.additionals.salaVacinacaoLogada.id) {
                    fields.push(
                        { key: 'quantidadeEnviada', label: 'Quantidade enviada' },
                        { key: 'lote', label: 'Lote' },
                        { key: 'dataValidadeLote', label: 'Validade do lote' },
                    )
                }

                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    fields.push(
                        { key: 'quantidadeEnviada', label: 'Quantidade enviada' },
                        { key: 'lote', label: 'Lote' },
                        { key: 'dataValidadeLote', label: 'Validade do lote' },
                        { key: 'quantidadeRecebida', label: 'Quantidade recebida' },
                    )
                }
            }

            return fields
        },
        modalTitle() {
            let title = ''

            if (this.model.statusId === this.enums.requisicaoStatus.PENDENTE) {
                title = 'Lotes disponíveis'
            }
            else if (this.model.statusId === this.enums.requisicaoStatus.RESPONDIDA) {
                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    title = 'Lotes recebidos'
                } else {
                    title = 'Lotes enviados'
                }
            }
            else if (this.model.statusId === this.enums.requisicaoStatus.FINALIZADA) {
                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    title = 'Lotes recebidos'
                } else {
                    title = 'Lotes enviados'
                }
            }

            return title
        },
        saveButtonShow() {
            let show = false

            if (this.model.statusId === this.enums.requisicaoStatus.PENDENTE) {
                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    show = false
                } else {
                    show = true
                }
            }
            else if (this.model.statusId === this.enums.requisicaoStatus.RESPONDIDA) {
                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    show = true
                } else {
                    show = false
                }
            }

            return show
        },
        cancelButtonTitle() {
            let title = 'Fechar'

            if (this.model.statusId === this.enums.requisicaoStatus.PENDENTE) {
                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    title = 'Fechar'
                } else {
                    title = 'Cancelar'
                }
            }
            else if (this.model.statusId === this.enums.requisicaoStatus.RESPONDIDA) {
                if (this.model.salaVacinacaoIdDe === this.additionals.salaVacinacaoLogada.id) {
                    title = 'Cancelar'
                } else {
                    title = 'Fechar'
                }
            }

            return title
        }
    },
    data: () => ({
        enums: { requisicaoStatus },
        item: null,
    }),
    methods: {
        open(item) {
            this.item = this.clone(item)
            this.$refs.RkmModal.show()
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    Object.assign(this.model.vacinas.find(vacina => vacina.id === this.item.id), this.item)

                    this.$refs.RkmModal.hide()
                })
        },
    },
    mixins: [ object ],
    props: {
        additionals: { type: Object, required: true },
        model: { type: Object, required: true },
    },
}
</script>